module.exports = __webpack_public_path__ + "static/media/settings-red.4334c45a.svg";